/* ── Sony Mony Electronics — Customer Account Portal ─────────────────────
   Login: mobile number + password (no OTP, no backend required).
   Phone is mapped to an internal email (p91XXXXXXXXXX@sonymony.co.in)
   for Shopify Storefront API authentication.
   All customer data fetched via Storefront API using a customer access token.
──────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var CFG      = window.smAC || {};
  var SF_URL   = 'https://sony-mony-electronics.myshopify.com/api/2024-10/graphql.json';
  var SF_TOK   = CFG.sfToken || '';
  var LOGO     = CFG.logo || '';
  var NL_URL   = 'https://bright-eclair-74a340.netlify.app/.netlify/functions';

  var TK  = 'sm_tk';
  var TX  = 'sm_tx';
  var BIZ = 'sm_biz';
  var SE  = 'sm_email';

  function getBiz() { try { return JSON.parse(ls(BIZ) || '{}'); } catch(e) { return {}; } }
  function setBiz(d) { lss(BIZ, JSON.stringify(d)); }

  /* ── token helpers ── */
  function tok() {
    var x = ls(TX);
    if (x && new Date(x) < new Date()) { clr(); return null; }
    return ls(TK);
  }
  function setTok(t, exp) { lss(TK, t); lss(TX, exp); }
  function clr() { [TK, TX].forEach(function(k) { try { localStorage.removeItem(k); } catch(e){} }); }
  function ls(k)    { try { return localStorage.getItem(k); }  catch(e) { return null; } }
  function lss(k,v) { try { localStorage.setItem(k, v); }      catch(e) {} }

  /* ── phone → internal auth email ── */
  function toEmail(raw) {
    var digits = raw.replace(/\D/g,'').slice(-10);
    return 'p91' + digits + '@sonymony.co.in';
  }

  /* ── Storefront API ── */
  function sf(query, vars) {
    return fetch(SF_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': SF_TOK
      },
      body: JSON.stringify({ query: query, variables: vars || {} })
    }).then(function(r) { return r.json(); });
  }

  /* ── GraphQL operations ── */
  var GQ = {
    login:
      'mutation($e:String!,$p:String!){customerAccessTokenCreate(input:{email:$e,password:$p})' +
      '{customerAccessToken{accessToken expiresAt}customerUserErrors{code message}}}',

    register:
      'mutation($i:CustomerCreateInput!){customerCreate(input:$i)' +
      '{customer{id firstName lastName}customerUserErrors{code field message}}}',

    customer:
      'query($t:String!){customer(customerAccessToken:$t){id firstName lastName email phone}}',

    orders:
      'query($t:String!){customer(customerAccessToken:$t){orders(first:30,sortKey:PROCESSED_AT,reverse:true){edges{node{' +
      'id orderNumber processedAt financialStatus fulfillmentStatus ' +
      'totalPrice{amount currencyCode} ' +
      'shippingAddress{firstName lastName address1 address2 city province country zip phone} ' +
      'lineItems(first:30){edges{node{title quantity ' +
      'variant{price{amount} image{url altText} product{handle}}}}}' +
      '}}}}',

    addresses:
      'query($t:String!){customer(customerAccessToken:$t){defaultAddress{id} ' +
      'addresses(first:20){edges{node{id firstName lastName address1 address2 city province country zip phone}}}}}',

    addrCreate:
      'mutation($t:String!,$a:MailingAddressInput!){customerAddressCreate(customerAccessToken:$t,address:$a)' +
      '{customerAddress{id} customerUserErrors{code field message}}}',

    addrUpdate:
      'mutation($t:String!,$id:ID!,$a:MailingAddressInput!){customerAddressUpdate(customerAccessToken:$t,id:$id,address:$a)' +
      '{customerAddress{id} customerUserErrors{code field message}}}',

    addrDelete:
      'mutation($t:String!,$id:ID!){customerAddressDelete(customerAccessToken:$t,id:$id)' +
      '{deletedCustomerAddressId customerUserErrors{code field message}}}',

    addrDefault:
      'mutation($t:String!,$id:ID!){customerDefaultAddressUpdate(customerAccessToken:$t,addressId:$id)' +
      '{customer{defaultAddress{id}} customerUserErrors{code field message}}}',

    customerUpdate:
      'mutation($t:String!,$i:CustomerUpdateInput!){customerUpdate(customerAccessToken:$t,customer:$i)' +
      '{customer{id email} customerUserErrors{code field message}}}',

    recover:
      'mutation($e:String!){customerRecover(email:$e){customerUserErrors{code message}}}'
  };

  /* ── state ── */
  var S = { tab:'orders', orders:null, addrs:null, defAddr:null, customer:null };

  /* ── Indian states dropdown ── */
  var IN_STATES = [
    {c:'AN',n:'Andaman & Nicobar Islands'},{c:'AP',n:'Andhra Pradesh'},
    {c:'AR',n:'Arunachal Pradesh'},{c:'AS',n:'Assam'},{c:'BR',n:'Bihar'},
    {c:'CH',n:'Chandigarh'},{c:'CT',n:'Chhattisgarh'},{c:'DL',n:'Delhi'},
    {c:'GA',n:'Goa'},{c:'GJ',n:'Gujarat'},{c:'HR',n:'Haryana'},
    {c:'HP',n:'Himachal Pradesh'},{c:'JK',n:'Jammu & Kashmir'},{c:'JH',n:'Jharkhand'},
    {c:'KA',n:'Karnataka'},{c:'KL',n:'Kerala'},{c:'LA',n:'Ladakh'},
    {c:'MP',n:'Madhya Pradesh'},{c:'MH',n:'Maharashtra'},{c:'MN',n:'Manipur'},
    {c:'ML',n:'Meghalaya'},{c:'MZ',n:'Mizoram'},{c:'NL',n:'Nagaland'},
    {c:'OR',n:'Odisha'},{c:'PB',n:'Punjab'},{c:'PY',n:'Puducherry'},
    {c:'RJ',n:'Rajasthan'},{c:'SK',n:'Sikkim'},{c:'TN',n:'Tamil Nadu'},
    {c:'TS',n:'Telangana'},{c:'TR',n:'Tripura'},{c:'UP',n:'Uttar Pradesh'},
    {c:'UK',n:'Uttarakhand'},{c:'WB',n:'West Bengal'}
  ];
  function resolveStateCode(val) {
    if (!val) return '';
    var upper = val.trim().toUpperCase();
    for (var i=0; i<IN_STATES.length; i++) { if (IN_STATES[i].c === upper) return upper; }
    var lower = val.trim().toLowerCase();
    for (var j=0; j<IN_STATES.length; j++) { if (IN_STATES[j].n.toLowerCase() === lower) return IN_STATES[j].c; }
    return '';
  }
  var SEL_ARROW = "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1.5l5 5 5-5' stroke='%231e2d7d' stroke-width='1.8' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\")";
  function stateSelectHtml(id, current) {
    var code = resolveStateCode(current || '');
    var style = 'appearance:none;-webkit-appearance:none;background-image:'+SEL_ARROW+';background-repeat:no-repeat;background-position:right 1rem center;background-size:12px 8px;padding-right:2.75rem;cursor:pointer';
    var h = '<select id="'+id+'" class="acc-inp" style="'+style+'"><option value="">Select State</option>';
    IN_STATES.forEach(function(s) {
      h += '<option value="'+s.c+'"'+(s.c===code?' selected':'')+'>'+esc(s.n)+'</option>';
    });
    return h + '</select>';
  }

  /* ── tiny helpers ── */
  function rupee(v) { return '₹' + Math.round(parseFloat(v)).toLocaleString('en-IN'); }
  function fdate(iso) { return new Date(iso).toLocaleDateString('en-IN', { day:'numeric', month:'short', year:'numeric' }); }
  function esc(s) { return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function badge(status) {
    var m = {
      PAID:['green','Paid'], PENDING:['amber','Pending'], REFUNDED:['gray','Refunded'],
      PARTIALLY_REFUNDED:['amber','Part Refunded'], VOIDED:['gray','Voided'],
      FULFILLED:['green','Delivered'], UNFULFILLED:['blue','Processing'],
      PARTIALLY_FULFILLED:['amber','Part Shipped'], IN_TRANSIT:['blue','In Transit'],
      RESTOCKED:['gray','Restocked']
    };
    var x = m[status] || ['gray', status];
    return '<span class="acc-badge bdg-'+x[0]+'">'+x[1]+'</span>';
  }
  function setMsg(id, txt, type) {
    var el = q(id); if (!el) return;
    el.textContent = txt;
    el.className = 'acc-msg' + (type==='err' ? ' acc-msg-err' : type==='ok' ? ' acc-msg-ok' : '');
  }
  function q(id) { return document.getElementById(id); }
  function root() { return q('acc-root'); }
  var SPIN = '<div class="acc-loading"><div class="acc-spinner"></div><p>Loading…</p></div>';

  /* ═══════════════════════════════════════════════════════════════════════
     AUTH — LOGIN & REGISTER
  ═══════════════════════════════════════════════════════════════════════ */
  var _authView = 'login'; // 'login' | 'register'

  function renderAuth() {
    root().innerHTML =
      '<div class="acc-auth">' +
        '<div class="acc-auth-logo"><a href="/"><img src="'+esc(LOGO)+'" alt="Sony Mony" height="34"></a></div>' +

        /* ── Login panel ── */
        '<div id="auth-login">' +
          '<div class="acc-auth-title">Sign In</div>' +
          '<div class="acc-auth-sub">Use your mobile number and password to sign in.</div>' +
          '<div class="acc-field"><label>Mobile Number</label>' +
            '<div class="acc-phone-wrap"><span class="acc-pfx">+91</span>' +
            '<input id="l-ph" class="acc-inp" type="tel" inputmode="numeric" maxlength="10" placeholder="98765 43210" autocomplete="tel"></div></div>' +
          '<div class="acc-field"><label>Password</label>' +
            '<input id="l-pw" class="acc-inp" type="password" autocomplete="current-password" placeholder="Your password"></div>' +
          '<div id="l-msg" class="acc-msg"></div>' +
          '<button class="acc-btn" id="l-btn">Sign In</button>' +
          '<p style="font-size:.8125rem;text-align:center;margin:.75rem 0 0">' +
            '<button style="background:none;border:none;color:var(--ac-muted);cursor:pointer;font-family:inherit;font-size:.8125rem;padding:0;text-decoration:underline" onclick="smAccShowForgot()">Forgot Password?</button>' +
          '</p>' +
          '<div class="acc-divider"></div>' +
          '<p style="font-size:.8125rem;text-align:center;color:var(--ac-muted);margin:0">Don\'t have an account? ' +
            '<button style="background:none;border:none;color:var(--ac);font-weight:700;cursor:pointer;font-family:inherit;font-size:.8125rem;padding:0" onclick="smAccShowReg()">Create one</button>' +
          '</p>' +
        '</div>' +

        /* ── Forgot Password panel ── */
        '<div id="auth-forgot" style="display:none">' +
          '<div class="acc-auth-title">Reset Password</div>' +
          '<div class="acc-auth-sub">Enter your registered mobile number. A password reset link will be sent to your email address.</div>' +
          '<div class="acc-field"><label>Mobile Number</label>' +
            '<div class="acc-phone-wrap"><span class="acc-pfx">+91</span>' +
            '<input id="f-ph" class="acc-inp" type="tel" inputmode="numeric" maxlength="10" placeholder="98765 43210" autocomplete="tel"></div></div>' +
          '<div id="f-msg" class="acc-msg"></div>' +
          '<button class="acc-btn" id="f-btn">Send Reset Link</button>' +
          '<div class="acc-divider"></div>' +
          '<p style="font-size:.8125rem;text-align:center;color:var(--ac-muted);margin:0">' +
            '<button style="background:none;border:none;color:var(--ac);font-weight:700;cursor:pointer;font-family:inherit;font-size:.8125rem;padding:0" onclick="smAccShowLogin()">← Back to Sign In</button>' +
          '</p>' +
        '</div>' +

        /* ── Register panel ── */
        '<div id="auth-reg" style="display:none">' +
          '<div class="acc-auth-title">Create Account</div>' +
          '<div class="acc-auth-sub">Set up your Sony Mony account with your mobile number.</div>' +
          '<div class="acc-row2">' +
            '<div class="acc-field" style="margin-bottom:0"><label>First Name *</label><input id="r-fn" class="acc-inp" type="text" autocomplete="given-name" placeholder="Rahul"></div>' +
            '<div class="acc-field" style="margin-bottom:0"><label>Last Name</label><input id="r-ln" class="acc-inp" type="text" autocomplete="family-name" placeholder="Sharma"></div>' +
          '</div>' +
          '<div style="height:.75rem"></div>'+
          '<div class="acc-field"><label>Mobile Number *</label>' +
            '<div class="acc-phone-wrap"><span class="acc-pfx">+91</span>' +
            '<input id="r-ph" class="acc-inp" type="tel" inputmode="numeric" maxlength="10" placeholder="98765 43210" autocomplete="tel"></div></div>' +
          '<div class="acc-field"><label>Password *</label>' +
            '<input id="r-pw" class="acc-inp" type="password" autocomplete="new-password" placeholder="Min. 5 characters"></div>' +
          '<div class="acc-field"><label>Confirm Password *</label>' +
            '<input id="r-pw2" class="acc-inp" type="password" autocomplete="new-password" placeholder="Repeat password"></div>' +
          '<div id="r-msg" class="acc-msg"></div>' +
          '<button class="acc-btn" id="r-btn">Create Account</button>' +
          '<div class="acc-divider"></div>' +
          '<p style="font-size:.8125rem;text-align:center;color:var(--ac-muted);margin:0">Already have an account? ' +
            '<button style="background:none;border:none;color:var(--ac);font-weight:700;cursor:pointer;font-family:inherit;font-size:.8125rem;padding:0" onclick="smAccShowLogin()">Sign in</button>' +
          '</p>' +
        '</div>' +

      '</div>';

    q('l-btn').addEventListener('click', doLogin);
    q('r-btn').addEventListener('click', doRegister);
    q('f-btn').addEventListener('click', doForgotPassword);
    q('l-ph').addEventListener('keydown', function(e){ if(e.key==='Enter') q('l-pw').focus(); });
    q('l-pw').addEventListener('keydown', function(e){ if(e.key==='Enter') doLogin(); });
    q('r-ph').addEventListener('keydown', function(e){ if(e.key==='Enter') q('r-pw').focus(); });
    q('r-pw').addEventListener('keydown', function(e){ if(e.key==='Enter') q('r-pw2').focus(); });
    q('r-pw2').addEventListener('keydown', function(e){ if(e.key==='Enter') doRegister(); });
    q('f-ph').addEventListener('keydown', function(e){ if(e.key==='Enter') doForgotPassword(); });
  }

  window.smAccShowReg = function() {
    q('auth-login').style.display='none';
    q('auth-forgot').style.display='none';
    q('auth-reg').style.display='';
    if(q('r-fn')) q('r-fn').focus();
  };
  window.smAccShowLogin = function() {
    q('auth-reg').style.display='none';
    q('auth-forgot').style.display='none';
    q('auth-login').style.display='';
    if(q('l-ph')) q('l-ph').focus();
  };
  window.smAccShowForgot = function() {
    q('auth-login').style.display='none';
    q('auth-reg').style.display='none';
    q('auth-forgot').style.display='';
    if(q('f-ph')) q('f-ph').focus();
  };

  function doForgotPassword() {
    var ph = (q('f-ph').value||'').replace(/\D/g,'');
    if (ph.length !== 10) { setMsg('f-msg','Enter a valid 10-digit mobile number.','err'); return; }
    var btn=q('f-btn'); btn.disabled=true; btn.textContent='Sending…';
    setMsg('f-msg','','');

    fetch(NL_URL + '/reset-init', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ phone: ph })
    })
      .then(function() {
        btn.disabled=false; btn.textContent='Send Reset Link';
        setMsg('f-msg','If an account exists for this number, a reset link has been sent to your registered email address.','ok');
      })
      .catch(function() {
        btn.disabled=false; btn.textContent='Send Reset Link';
        setMsg('f-msg','Something went wrong. Please try again.','err');
      });
  }

  function doLogin() {
    var ph = (q('l-ph').value||'').replace(/\D/g,'');
    var pw = (q('l-pw').value||'');
    if (ph.length !== 10) { setMsg('l-msg','Enter a valid 10-digit mobile number.','err'); return; }
    if (!pw) { setMsg('l-msg','Enter your password.','err'); return; }
    var btn=q('l-btn'); btn.disabled=true; btn.textContent='Signing in…';
    setMsg('l-msg','','');

    /* Try phone-mapped internal email first; if customer updated to real email, fall back to stored email */
    sf(GQ.login, { e: toEmail(ph), p: pw })
      .then(function(res) {
        var r = res.data && res.data.customerAccessTokenCreate;
        if (r && r.customerAccessToken) {
          setTok(r.customerAccessToken.accessToken, r.customerAccessToken.expiresAt);
          window.location.reload();
          return;
        }
        /* Internal email failed — try stored real email (set after profile update) */
        var realEm = ls(SE);
        if (realEm) {
          return sf(GQ.login, { e: realEm, p: pw }).then(function(res2) {
            var r2 = res2.data && res2.data.customerAccessTokenCreate;
            if (r2 && r2.customerAccessToken) {
              setTok(r2.customerAccessToken.accessToken, r2.customerAccessToken.expiresAt);
              window.location.reload();
              return;
            }
            btn.disabled=false; btn.textContent='Sign In';
            setMsg('l-msg','Incorrect mobile number or password.','err');
          });
        }
        btn.disabled=false; btn.textContent='Sign In';
        var msg = (r && r.customerUserErrors && r.customerUserErrors[0] && r.customerUserErrors[0].message) || '';
        setMsg('l-msg', msg.indexOf('Unidentified customer')>=0
          ? 'Incorrect mobile number or password.' : (msg || 'Login failed. Please try again.'), 'err');
      })
      .catch(function() { btn.disabled=false; btn.textContent='Sign In'; setMsg('l-msg','Network error. Please try again.','err'); });
  }

  function doRegister() {
    var fn=(q('r-fn').value||'').trim();
    var ln=(q('r-ln').value||'').trim();
    var ph=(q('r-ph').value||'').replace(/\D/g,'');
    var pw=(q('r-pw').value||'');
    var pw2=(q('r-pw2').value||'');

    if (!fn) { setMsg('r-msg','First name is required.','err'); return; }
    if (ph.length !== 10) { setMsg('r-msg','Enter a valid 10-digit mobile number.','err'); return; }
    if (pw.length < 5) { setMsg('r-msg','Password must be at least 5 characters.','err'); return; }
    if (pw !== pw2) { setMsg('r-msg','Passwords do not match.','err'); return; }

    var btn=q('r-btn'); btn.disabled=true; btn.textContent='Creating account…';
    setMsg('r-msg','','');

    sf(GQ.register, {
      i: {
        firstName: fn, lastName: ln,
        email: toEmail(ph),
        phone: '+91' + ph,
        password: pw,
        acceptsMarketing: false
      }
    })
    .then(function(res) {
      var r = res.data && res.data.customerCreate;
      if (r && r.customer) {
        return sf(GQ.login, { e: toEmail(ph), p: pw });
      }
      var errs = (r && r.customerUserErrors) || [];
      btn.disabled=false; btn.textContent='Create Account';
      var msg = errs.length ? errs[0].message : 'Registration failed.';
      if (msg.toLowerCase().indexOf('email') >= 0 || msg.toLowerCase().indexOf('phone') >= 0)
        msg = 'This mobile number is already registered. Please sign in.';
      setMsg('r-msg', msg, 'err');
      return null;
    })
    .then(function(res) {
      if (!res) return;
      var r = res.data && res.data.customerAccessTokenCreate;
      if (r && r.customerAccessToken) {
        setTok(r.customerAccessToken.accessToken, r.customerAccessToken.expiresAt);
        window.location.reload();
      } else {
        btn.disabled=false; btn.textContent='Create Account';
        setMsg('r-msg','Account created. Please sign in.','ok');
        setTimeout(window.smAccShowLogin, 1200);
      }
    })
    .catch(function() { btn.disabled=false; btn.textContent='Create Account'; setMsg('r-msg','Network error. Please try again.','err'); });
  }

  /* ═══════════════════════════════════════════════════════════════════════
     DASHBOARD
  ═══════════════════════════════════════════════════════════════════════ */
  function renderDash() {
    root().innerHTML =
      '<div class="acc-pg"><div class="acc-wrap">' +
      '<div class="acc-hd">' +
        '<div><div class="acc-greet" id="acc-greet">Hello 👋</div>' +
        '<div id="acc-ph-show" style="font-size:.825rem;color:var(--ac-muted);margin-top:.1rem"></div></div>' +
        '<button class="acc-logout" onclick="smAccLogout()">' +
          '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>' +
          'Sign Out' +
        '</button>' +
      '</div>' +
      '<div class="acc-tabs">' +
        '<button class="acc-tab-btn on" id="tb-orders" onclick="smAccTab(\'orders\')">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
          'My Orders' +
        '</button>' +
        '<button class="acc-tab-btn" id="tb-profile" onclick="smAccTab(\'profile\')">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>' +
          'My Profile' +
        '</button>' +
      '</div>' +
      '<div id="acc-body">'+SPIN+'</div>' +
      '</div></div>';

    loadCustomer();
    showOrders();
  }

  function loadCustomer() {
    sf(GQ.customer, { t: tok() }).then(function(res) {
      var c = res.data && res.data.customer; if (!c) return;
      S.customer = c;
      var g = q('acc-greet'); if (g) g.textContent = 'Hi, ' + c.firstName + ' 👋';
      var ph = q('acc-ph-show');
      if (ph && c.phone) ph.textContent = c.phone;
    });
  }

  window.smAccLogout = function() { clr(); window.location.reload(); };

  window.smAccTab = function(tab) {
    S.tab = tab;
    document.querySelectorAll('.acc-tab-btn').forEach(function(b) { b.classList.remove('on'); });
    var btn = q('tb-'+tab); if (btn) btn.classList.add('on');
    if (tab === 'orders')  { S.orders = null; showOrders(); }
    if (tab === 'profile') showProfile();
  };

  /* ═══════════════════════════════════════════════════════════════════════
     ORDERS
  ═══════════════════════════════════════════════════════════════════════ */
  function ordersErrHtml(msg) {
    return '<div class="acc-empty"><div class="acc-empty-icon">📦</div>' +
      '<p>' + msg + '</p>' +
      '<button class="acc-btn" style="margin-top:1rem" onclick="smAccRefreshOrders()">↻ Refresh</button></div>';
  }

  function showOrders() {
    var body = q('acc-body'); if (!body) return;
    if (S.orders !== null) { drawOrders(S.orders); return; }
    var t = tok();
    if (!t) {
      body.innerHTML = ordersErrHtml('Please sign in to view your orders.');
      return;
    }
    body.innerHTML = SPIN;
    sf(GQ.orders, { t: t })
      .then(function(res) {
        if (res.errors) { console.warn('[SM] Orders GraphQL errors:', JSON.stringify(res.errors)); }
        var cust = res.data && res.data.customer;
        if (!cust) {
          body.innerHTML = ordersErrHtml('Could not load your orders. Please try again.');
          return;
        }
        S.orders = (cust.orders && cust.orders.edges) || [];
        drawOrders(S.orders);
      })
      .catch(function(err) {
        console.error('[SM] Orders fetch error:', err);
        body.innerHTML = ordersErrHtml('Could not load your orders. Check your connection and try again.');
      });
  }

  window.smAccRefreshOrders = function() { S.orders = null; showOrders(); };

  function drawOrders(edges) {
    var body = q('acc-body'); if (!body) return;
    if (!edges.length) {
      body.innerHTML = '<div class="acc-empty"><div class="acc-empty-icon">📦</div>' +
        '<p>No orders yet.</p>' +
        '<p><a href="/collections/all">Start shopping →</a></p>' +
        '<p style="margin-top:1.5rem;font-size:.8125rem;color:var(--ac-muted)">Just placed an order? ' +
        '<button onclick="smAccRefreshOrders()" style="background:none;border:none;color:var(--ac);cursor:pointer;font-family:inherit;font-size:inherit;padding:0;text-decoration:underline">Refresh</button>' +
        ' — orders may take a moment to appear.</p></div>';
      return;
    }
    var html =
      '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:.75rem">' +
        '<div style="font-weight:600;font-size:.9375rem">My Orders</div>' +
        '<button onclick="smAccRefreshOrders()" style="background:none;border:none;color:var(--ac);cursor:pointer;font-family:inherit;font-size:.8125rem;padding:0">↻ Refresh</button>' +
      '</div>' +
      '<div class="acc-orders">';
    edges.forEach(function(e) {
      var o = e.node;
      var names = o.lineItems.edges.map(function(x) { return x.node.title; }).join(', ');
      var qty   = o.lineItems.edges.reduce(function(a,x) { return a + x.node.quantity; }, 0);
      html +=
        '<div class="acc-ocard" onclick="smAccOrder(\''+esc(o.id)+'\')">' +
          '<div class="acc-ocard-r1">' +
            '<div><div class="acc-ocard-num">Order #'+o.orderNumber+'</div>' +
            '<div class="acc-ocard-date">'+fdate(o.processedAt)+'</div></div>' +
            '<div class="acc-badges">'+badge(o.financialStatus)+badge(o.fulfillmentStatus)+'</div>' +
          '</div>' +
          '<div class="acc-ocard-r2">' +
            '<div class="acc-ocard-items">'+qty+' item'+(qty!==1?'s':'')+' · '+esc(names.substring(0,70))+(names.length>70?'…':'')+'</div>' +
            '<div class="acc-ocard-amt">'+rupee(o.totalPrice.amount)+'</div>' +
          '</div>' +
        '</div>';
    });
    html += '</div></div>';
    body.innerHTML = html;
  }

  window.smAccOrder = function(id) {
    var edge = S.orders && S.orders.find(function(e) { return e.node.id === id; });
    if (!edge) return;
    var o = edge.node;
    var body = q('acc-body'); if (!body) return;

    var items = '';
    o.lineItems.edges.forEach(function(e) {
      var li = e.node;
      var img = li.variant && li.variant.image
        ? '<img class="acc-li-img" src="'+esc(li.variant.image.url)+'" alt="'+esc(li.variant.image.altText||li.title)+'" loading="lazy">'
        : '<div class="acc-li-ph"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg></div>';
      items +=
        '<div class="acc-li">'+img+
          '<div style="flex:1;min-width:0">'+
            '<div class="acc-li-title">'+esc(li.title)+'</div>'+
            '<div class="acc-li-qty">Qty: '+li.quantity+'</div>'+
          '</div>'+
          '<div class="acc-li-price">'+(li.variant && li.variant.price ? rupee(parseFloat(li.variant.price.amount) * li.quantity) : '')+'</div>'+
        '</div>';
    });

    var sa = o.shippingAddress;
    var shipTxt = sa
      ? [sa.firstName+' '+(sa.lastName||''), sa.address1, sa.address2, sa.city, sa.province, sa.zip, sa.country].filter(Boolean).join(', ')
      : 'Not available';

    body.innerHTML =
      '<button class="acc-back" onclick="smAccOrders()">'+
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>'+
        'All Orders'+
      '</button>'+
      '<div class="acc-od-hd">'+
        '<div><div class="acc-od-num">Order #'+o.orderNumber+'</div>'+
        '<div class="acc-od-meta">Placed on '+fdate(o.processedAt)+'</div></div>'+
        '<div class="acc-badges">'+badge(o.financialStatus)+badge(o.fulfillmentStatus)+'</div>'+
      '</div>'+
      '<div class="acc-od-grid">'+
        '<div><div class="acc-card"><div class="acc-card-title">Items Ordered</div>'+items+'</div></div>'+
        '<div>'+
          '<div class="acc-card"><div class="acc-card-title">Order Summary</div>'+
            '<div class="acc-sum-row tot"><span>Total</span><span>'+rupee(o.totalPrice.amount)+'</span></div>'+
            '<div class="acc-sum-row" style="font-size:.8rem;opacity:.7"><span>Status</span><span>'+badge(o.financialStatus)+'</span></div>'+
          '</div>'+
          '<div class="acc-card"><div class="acc-card-title">Delivery Address</div>'+
            '<div class="acc-info-val">'+esc(shipTxt)+'</div>'+
            (sa&&sa.phone ? '<div class="acc-info-val" style="margin-top:.5rem;font-size:.8125rem;color:var(--ac-muted)">📞 '+esc(sa.phone)+'</div>' : '')+
          '</div>'+
        '</div>'+
      '</div>';
  };

  window.smAccOrders = function() { drawOrders(S.orders||[]); };

  /* ═══════════════════════════════════════════════════════════════════════
     ADDRESSES
  ═══════════════════════════════════════════════════════════════════════ */
  function buildAddressesHtml(addrs, defId) {
    var html = '<div class="acc-addr-grid">';
    addrs.forEach(function(a) {
      var isDef = a.id === defId;
      var lines = [a.address1, a.address2, a.city, a.province, a.zip, a.country].filter(Boolean).join(', ');
      html +=
        '<div class="acc-addr-card'+(isDef?' is-def':'')+'">' +
          (isDef ? '<div class="acc-def-badge">Default</div>' : '') +
          '<div class="acc-addr-name">'+esc(a.firstName+' '+(a.lastName||''))+'</div>'+
          (a.company ? '<div class="acc-addr-co">🏢 '+esc(a.company)+'</div>' : '')+
          '<div class="acc-addr-line">'+esc(lines)+'</div>'+
          (a.phone ? '<div class="acc-addr-line" style="margin-top:.375rem">📞 '+esc(a.phone)+'</div>' : '')+
          '<div class="acc-addr-acts">'+
            (!isDef ? '<button class="acc-addr-act" onclick="smAccDefAddr(\''+esc(a.id)+'\')">Set Default</button>' : '')+
            '<button class="acc-addr-act" onclick="smAccEditAddr(\''+esc(a.id)+'\')">Edit</button>'+
            '<button class="acc-addr-act del" onclick="smAccDelAddr(\''+esc(a.id)+'\')">Delete</button>'+
          '</div>'+
        '</div>';
    });
    html += '<div class="acc-addr-add" onclick="smAccAddAddr()"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>Add New Address</div>';
    html += '</div>';
    return html;
  }

  function wireAddressModal() { /* modal is built on-demand; nothing to wire here */ }

  function showAddressesInProfile() {
    var body = q('acc-body'); if (!body) return;
    S.addrs = null;
    body.innerHTML = profileSubNav('addresses') + '<div id="prof-sub-body" style="margin-top:1rem">'+SPIN+'</div>';
    sf(GQ.addresses, { t: tok() }).then(function(res) {
      var pb = document.getElementById('prof-sub-body'); if (!pb) return;
      var c = res.data && res.data.customer;
      if (!c) { pb.innerHTML = '<div class="acc-empty"><p>Could not load addresses.</p></div>'; return; }
      S.addrs   = c.addresses.edges.map(function(e) { return e.node; });
      S.defAddr = c.defaultAddress ? c.defaultAddress.id : null;
      cacheDefaultAddr(S.addrs, S.defAddr);
      pb.innerHTML = buildAddressesHtml(S.addrs, S.defAddr);
    });
  }

  function openAddrModal(a) {
    var isEdit = !!a;
    var bd = document.createElement('div');
    bd.className = 'acc-modal-bg'; bd.id = 'acc-modal-bg';
    bd.innerHTML =
      '<div class="acc-modal">'+
        '<div class="acc-modal-hd">'+
          '<div class="acc-modal-title">'+(isEdit?'Edit Address':'Add New Address')+'</div>'+
          '<button class="acc-modal-x" onclick="smAccCloseModal()"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></button>'+
        '</div>'+
        '<div class="acc-row2" style="margin-bottom:.75rem">'+
          '<div class="acc-field" style="margin-bottom:0"><label>First Name *</label><input id="af-fn" class="acc-inp" value="'+esc(a?a.firstName||'':'')+'" autocomplete="given-name"></div>'+
          '<div class="acc-field" style="margin-bottom:0"><label>Last Name</label><input id="af-ln" class="acc-inp" value="'+esc(a?a.lastName||'':'')+'" autocomplete="family-name"></div>'+
        '</div>'+
        '<div class="acc-field"><label>Company / Organisation</label><input id="af-co" class="acc-inp" value="'+esc(a?a.company||'':'')+'" autocomplete="organization" placeholder="Optional — for business deliveries"></div>'+
        '<div class="acc-field"><label>Address Line 1 *</label><input id="af-a1" class="acc-inp" value="'+esc(a?a.address1||'':'')+'" autocomplete="address-line1" placeholder="Flat / House No, Street"></div>'+
        '<div class="acc-field"><label>Address Line 2</label><input id="af-a2" class="acc-inp" value="'+esc(a?a.address2||'':'')+'" autocomplete="address-line2" placeholder="Landmark, Area (optional)"></div>'+
        '<div class="acc-row2" style="margin-bottom:.75rem">'+
          '<div class="acc-field" style="margin-bottom:0"><label>City *</label><input id="af-ct" class="acc-inp" value="'+esc(a?a.city||'':'')+'" autocomplete="address-level2"></div>'+
          '<div class="acc-field" style="margin-bottom:0"><label>State</label>'+stateSelectHtml('af-st', a?a.province||'':'')+'</div>'+
        '</div>'+
        '<div class="acc-row2" style="margin-bottom:.75rem">'+
          '<div class="acc-field" style="margin-bottom:0"><label>PIN Code *</label><input id="af-zp" class="acc-inp" value="'+esc(a?a.zip||'':'')+'" inputmode="numeric" placeholder="400001"></div>'+
          '<div class="acc-field" style="margin-bottom:0"><label>Phone</label><input id="af-ph" class="acc-inp" value="'+esc(a?a.phone||'':'')+'" type="tel" placeholder="+91 98765 43210"></div>'+
        '</div>'+
        '<div id="af-msg" class="acc-msg" style="margin-bottom:.625rem"></div>'+
        '<button class="acc-btn" id="af-save" onclick="smAccSaveAddr(\''+esc(a?a.id:'')+'\')">'+
          (isEdit?'Update Address':'Save Address')+
        '</button>'+
      '</div>';
    bd.addEventListener('click', function(e) { if (e.target===bd) smAccCloseModal(); });
    document.body.appendChild(bd);
    document.body.style.overflow = 'hidden';
    var fn = q('af-fn'); if (fn) fn.focus();
  }

  window.smAccAddAddr   = function() { openAddrModal(null); };
  window.smAccEditAddr  = function(id) {
    var a = S.addrs && S.addrs.find(function(x) { return x.id===id; });
    if (a) openAddrModal(a);
  };
  window.smAccCloseModal = function() {
    var bd = q('acc-modal-bg'); if (bd) bd.remove();
    document.body.style.overflow = '';
  };

  window.smAccSaveAddr = function(editId) {
    var fn=(q('af-fn').value||'').trim(), ln=(q('af-ln').value||'').trim(),
        co=(q('af-co').value||'').trim(),
        a1=(q('af-a1').value||'').trim(), a2=(q('af-a2').value||'').trim(),
        ct=(q('af-ct').value||'').trim(), st=(q('af-st').value||'').trim(),
        zp=(q('af-zp').value||'').trim(), ph=(q('af-ph').value||'').trim();
    if (!fn||!a1||!ct||!zp) { setMsg('af-msg','Please fill all required fields (*).','err'); return; }
    var btn=q('af-save'); btn.disabled=true; btn.textContent='Saving…';
    var addr={firstName:fn,lastName:ln,company:co,address1:a1,address2:a2,city:ct,province:st,country:'India',zip:zp,phone:ph};
    var p = editId
      ? sf(GQ.addrUpdate, { t:tok(), id:editId, a:addr })
      : sf(GQ.addrCreate, { t:tok(), a:addr });
    p.then(function(res) {
      var errs = ((res.data&&(res.data.customerAddressCreate||res.data.customerAddressUpdate))||{}).customerUserErrors||[];
      if (errs.length) { btn.disabled=false; btn.textContent=editId?'Update Address':'Save Address'; setMsg('af-msg',errs[0].message,'err'); return; }
      S.addrs=null; smAccCloseModal(); showAddressesInProfile();
    }).catch(function() { btn.disabled=false; btn.textContent=editId?'Update Address':'Save Address'; setMsg('af-msg','Network error.','err'); });
  };

  window.smAccDelAddr = function(id) {
    if (!confirm('Delete this address?')) return;
    sf(GQ.addrDelete, { t:tok(), id:id }).then(function() { S.addrs=null; showAddressesInProfile(); });
  };
  window.smAccDefAddr = function(id) {
    sf(GQ.addrDefault, { t:tok(), id:id }).then(function() { S.addrs=null; showAddressesInProfile(); });
  };

  /* ── Cache default address for PIN widget on product pages ── */
  function cacheDefaultAddr(addrs, defId) {
    var def = addrs.find(function(a) { return a.id === defId; }) || addrs[0];
    if (def) {
      lss('sm_defaddr', JSON.stringify({
        zip: def.zip, city: def.city,
        address1: def.address1, firstName: def.firstName, phone: def.phone
      }));
    }
  }

  /* ═══════════════════════════════════════════════════════════════════════
     PROFILE
  ═══════════════════════════════════════════════════════════════════════ */
  var S_PROF_SUB = 'info'; /* current profile sub-tab */

  function profileSubNav(active) {
    return '<div class="acc-sub-nav">' +
      '<button class="acc-sub-btn'+(active==='info'?' on':'')+'" onclick="smAccProfileTab(\'info\')">Personal Info</button>' +
      '<button class="acc-sub-btn'+(active==='addresses'?' on':'')+'" onclick="smAccProfileTab(\'addresses\')">Addresses</button>' +
      '<button class="acc-sub-btn'+(active==='business'?' on':'')+'" onclick="smAccProfileTab(\'business\')">Business</button>' +
    '</div>';
  }

  function showProfile() {
    S_PROF_SUB = 'info';
    renderProfileInfo();
  }

  function profileInfoCard(emailEditMode) {
    var c = S.customer || {};
    var storedEmail = ls(SE) || '';
    var phone = c.phone ? c.phone.replace('+91','').trim() : '';
    var phoneFmt = phone ? '+91 ' + phone.replace(/(\d{5})(\d{5})/, '$1 $2') : '—';

    var emailSection;
    if (storedEmail && !emailEditMode) {
      emailSection =
        '<div class="acc-divider" style="margin:1rem 0"></div>' +
        '<div style="display:flex;justify-content:space-between;align-items:center">' +
          '<div class="acc-card-title" style="font-size:.875rem;margin:0">Email Address</div>' +
          '<button onclick="smAccEditEmail()" class="acc-edit-btn">Edit</button>' +
        '</div>' +
        '<div class="acc-info-row" style="margin-top:.5rem"><span class="acc-info-lbl">Email</span><span class="acc-info-val">'+esc(storedEmail)+'</span></div>' +
        '<p style="font-size:.8rem;color:var(--ac-muted);margin:.4rem 0 0">Order confirmations will be sent here.</p>';
    } else {
      emailSection =
        '<div class="acc-divider" style="margin:1rem 0"></div>' +
        '<div class="acc-card-title" style="font-size:.875rem">Email Address</div>' +
        '<p style="font-size:.8125rem;color:var(--ac-muted);margin:.25rem 0 .75rem">Used for order confirmations and account communications.</p>' +
        '<div class="acc-field"><label>Email</label>' +
          '<input id="pr-em" class="acc-inp" type="email" value="'+esc(storedEmail)+'" placeholder="yourname@example.com" autocomplete="email">' +
        '</div>' +
        '<div id="pr-msg" class="acc-msg"></div>' +
        '<div style="display:flex;gap:.625rem">' +
          '<button class="acc-btn" id="pr-em-btn" onclick="smAccSaveEmail()" style="flex:1">Save Email</button>' +
          (storedEmail ? '<button onclick="renderProfileInfo()" style="background:none;border:1px solid #d1d5db;border-radius:12px;padding:.625rem 1rem;cursor:pointer;font-family:inherit;font-size:.875rem;color:#6b7280">Cancel</button>' : '') +
        '</div>';
    }

    return profileSubNav('info') +
      '<div class="acc-card" style="max-width:480px;margin-top:1rem">' +
        '<div class="acc-card-title">Personal Info</div>' +
        '<div class="acc-info-row"><span class="acc-info-lbl">Name</span><span class="acc-info-val">'+esc((c.firstName||'')+' '+(c.lastName||''))+'</span></div>' +
        '<div class="acc-info-row"><span class="acc-info-lbl">Mobile</span><span class="acc-info-val">'+esc(phoneFmt)+'</span></div>' +
        emailSection +
      '</div>';
  }

  function renderProfileInfo() {
    var body = q('acc-body'); if (!body) return;
    body.innerHTML = profileInfoCard(false);
  }

  window.smAccEditEmail = function() {
    var body = q('acc-body'); if (!body) return;
    body.innerHTML = profileInfoCard(true);
    var inp = q('pr-em'); if (inp) inp.focus();
  };

  window.smAccProfileTab = function(sub) {
    S_PROF_SUB = sub;
    if (sub === 'info')      { renderProfileInfo(); return; }
    if (sub === 'addresses') { showAddressesInProfile(); return; }
    if (sub === 'business')  { showBusinessInProfile(); return; }
  };

  function showAddressesInProfile() {
    var body = q('acc-body'); if (!body) return;
    body.innerHTML = profileSubNav('addresses') + '<div id="prof-sub-body" style="margin-top:1rem">'+SPIN+'</div>';
    S.addrs = null; /* force fresh load */
    sf(GQ.addresses, { t: tok() })
      .then(function(res) {
        var pb = document.getElementById('prof-sub-body'); if (!pb) return;
        var d = res.data && res.data.customer;
        if (!d) { pb.innerHTML = '<p style="color:red">Could not load addresses.</p>'; return; }
        S.addrs   = (d.addresses && d.addresses.edges.map(function(e){ return e.node; })) || [];
        S.defAddr = d.defaultAddress && d.defaultAddress.id;
        cacheDefaultAddr(S.addrs, S.defAddr);
        pb.innerHTML = buildAddressesHtml(S.addrs, S.defAddr);
        wireAddressModal();
      })
      .catch(function() { var pb=document.getElementById('prof-sub-body'); if(pb) pb.innerHTML='<p>Error loading.</p>'; });
  }

  function showBusinessInProfile() {
    var body = q('acc-body'); if (!body) return;
    body.innerHTML = profileSubNav('business') + '<div style="margin-top:1rem">' + buildBusinessHtml() + '</div>';
    wireBusinessForm();
  }

  window.smAccSaveEmail = function() {
    var em = (q('pr-em') ? q('pr-em').value.trim().toLowerCase() : '');
    if (!em || em.indexOf('@') < 0) { setMsg('pr-msg','Enter a valid email address.','err'); return; }
    var btn = q('pr-em-btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Saving…'; }
    sf(GQ.customerUpdate, { t: tok(), i: { email: em } })
      .then(function(res) {
        if (btn) { btn.disabled = false; btn.textContent = 'Save Email'; }
        var r = res.data && res.data.customerUpdate;
        if (r && r.customer) {
          lss(SE, em);
          renderProfileInfo(); /* switch to view mode */
          return;
        } else {
          var err = (r && r.customerUserErrors && r.customerUserErrors[0]) || {};
          var msg = err.message || 'Could not save email.';
          if (msg.toLowerCase().indexOf('taken') >= 0)
            msg = 'This email is already linked to another account. Use a different email.';
          setMsg('pr-msg', msg, 'err');
        }
      })
      .catch(function() {
        if (btn) { btn.disabled = false; btn.textContent = 'Save Email'; }
        setMsg('pr-msg', 'Network error. Please try again.', 'err');
      });
  };

  /* ═══════════════════════════════════════════════════════════════════════
     BUSINESS ACCOUNT
  ═══════════════════════════════════════════════════════════════════════ */
  function buildBusinessHtml() {
    var biz = getBiz();
    var b = biz.billing || {};
    var enabled = !!biz.enabled;
    var bizEditMode  = !!window._bizEdit;
    var billEditMode = !!window._billEdit;
    window._bizEdit  = false;
    window._billEdit = false;

    /* ── Business info card: view or edit ── */
    var bizCard;
    if (enabled && biz.company && !bizEditMode) {
      bizCard =
        '<div class="acc-card biz-card">' +
          '<div style="display:flex;justify-content:space-between;align-items:center">' +
            '<div class="acc-card-title" style="margin:0">Business Account</div>' +
            '<button onclick="smAccEditBiz()" class="acc-edit-btn">Edit</button>' +
          '</div>' +
          '<div class="acc-info-row" style="margin-top:.75rem"><span class="acc-info-lbl">Company</span><span class="acc-info-val">'+esc(biz.company)+'</span></div>' +
          (biz.gstin ? '<div class="acc-info-row"><span class="acc-info-lbl">GSTIN</span><span class="acc-info-val">'+esc(biz.gstin)+'</span></div>' : '') +
        '</div>';
    } else {
      bizCard =
        '<div class="acc-card biz-card">' +
          '<div class="acc-card-title">Business Account</div>' +
          '<label class="biz-toggle-row">' +
            '<input type="checkbox" id="biz-on" class="biz-chk"'+(enabled?' checked':'')+'>'+
            '<span class="biz-toggle-label">Enable business account billing</span>' +
          '</label>' +
          '<div id="biz-fields" style="'+(enabled?'':'display:none')+'">' +
            '<div class="acc-field"><label>Company / Business Name *</label>' +
              '<input id="biz-co" class="acc-inp" value="'+esc(biz.company||'')+'" placeholder="e.g. ABC Electronics Pvt Ltd" autocomplete="organization"></div>' +
            '<div class="acc-field"><label>GSTIN</label>' +
              '<input id="biz-gst" class="acc-inp" value="'+esc(biz.gstin||'')+'" maxlength="15" placeholder="e.g. 27AABCU9603R1ZX" style="text-transform:uppercase" oninput="smAccGstInput(this)">' +
            '</div>' +
            '<div id="biz-gst-info" class="biz-gst-info"></div>' +
            '<p class="biz-hint">15-character GSTIN. &nbsp;·&nbsp; <a href="https://services.gst.gov.in/services/searchtp" target="_blank" rel="noopener" style="color:var(--ac)">Verify on GST Portal →</a></p>' +
            '<div id="biz-msg" class="acc-msg"></div>' +
            '<button class="acc-btn" onclick="smAccSaveBiz()">Save Business Info</button>' +
          '</div>' +
        '</div>';
    }

    /* ── Billing address card: view or edit ── */
    var billingCard = '';
    if (enabled) {
      if (b.address1 && !billEditMode) {
        var lines = [b.address1, b.address2, b.city, b.state, b.zip].filter(Boolean).join(', ');
        billingCard =
          '<div class="acc-card biz-card">' +
            '<div style="display:flex;justify-content:space-between;align-items:center">' +
              '<div class="acc-card-title" style="margin:0">Billing Address</div>' +
              '<button onclick="smAccEditBilling()" class="acc-edit-btn">Edit</button>' +
            '</div>' +
            (b.company ? '<div class="acc-info-row" style="margin-top:.75rem"><span class="acc-info-lbl">Company</span><span class="acc-info-val">'+esc(b.company)+'</span></div>' : '') +
            (b.gstin   ? '<div class="acc-info-row"><span class="acc-info-lbl">GSTIN</span><span class="acc-info-val">'+esc(b.gstin)+'</span></div>' : '') +
            '<div class="acc-info-row'+(b.company||b.gstin?'':' style="margin-top:.75rem"')+'"><span class="acc-info-lbl">Address</span><span class="acc-info-val">'+esc(lines)+'</span></div>' +
            (b.phone ? '<div class="acc-info-row"><span class="acc-info-lbl">Phone</span><span class="acc-info-val">'+esc(b.phone.replace(/^\+91(\d{5})(\d{5})$/,'+91 $1 $2'))+'</span></div>' : '') +
          '</div>';
      } else {
        billingCard =
          '<div class="acc-card biz-card">' +
            '<div class="acc-card-title">Billing Address</div>' +
            '<p class="biz-hint" style="margin-top:0">Used for GST invoices. Can differ from delivery address.</p>' +
            '<div class="acc-row2" style="margin-bottom:.75rem">' +
              '<div class="acc-field" style="margin-bottom:0"><label>Company Name</label><input id="bb-co" class="acc-inp" value="'+esc(b.company||biz.company||'')+'" placeholder="ABC Electronics Pvt Ltd"></div>' +
              '<div class="acc-field" style="margin-bottom:0"><label>GSTIN (on invoice)</label><input id="bb-gst" class="acc-inp" value="'+esc(b.gstin||biz.gstin||'')+'" maxlength="15" placeholder="27AABCU9603R1ZX" style="text-transform:uppercase"></div>' +
            '</div>' +
            '<div class="acc-field"><label>Address Line 1 *</label><input id="bb-a1" class="acc-inp" value="'+esc(b.address1||'')+'" placeholder="Building, Street"></div>' +
            '<div class="acc-field"><label>Address Line 2</label><input id="bb-a2" class="acc-inp" value="'+esc(b.address2||'')+'" placeholder="Area, Landmark (optional)"></div>' +
            '<div class="acc-row2" style="margin-bottom:.75rem">' +
              '<div class="acc-field" style="margin-bottom:0"><label>City *</label><input id="bb-ct" class="acc-inp" value="'+esc(b.city||'')+'"></div>' +
              '<div class="acc-field" style="margin-bottom:0"><label>State *</label>'+stateSelectHtml('bb-st', b.state||'')+'</div>' +
            '</div>' +
            '<div class="acc-row2" style="margin-bottom:.75rem">' +
              '<div class="acc-field" style="margin-bottom:0"><label>PIN Code *</label><input id="bb-zp" class="acc-inp" value="'+esc(b.zip||'')+'" inputmode="numeric" placeholder="400001"></div>' +
              '<div class="acc-field" style="margin-bottom:0"><label>Phone</label><input id="bb-ph" class="acc-inp" value="'+esc(b.phone||'')+'" type="tel" placeholder="+91 98765 43210"></div>' +
            '</div>' +
            '<div style="display:flex;gap:.625rem">' +
              '<button class="acc-btn" onclick="smAccSaveBilling()" style="flex:1">Save Billing Address</button>' +
              (b.address1 ? '<button onclick="smAccCancelBilling()" style="background:none;border:1px solid #d1d5db;border-radius:12px;padding:.625rem 1rem;cursor:pointer;font-family:inherit;font-size:.875rem;color:#6b7280">Cancel</button>' : '') +
            '</div>' +
            '<div id="bb-msg" class="acc-msg"></div>' +
          '</div>';
      }
    }

    return '<div class="biz-wrap">' + bizCard + billingCard + '</div>';
  }

  function wireBusinessForm() {
    var chk = q('biz-on');
    if (chk) chk.addEventListener('change', function() {
      var fields = q('biz-fields');
      if (fields) fields.style.display = this.checked ? '' : 'none';
      if (!this.checked) { var d = getBiz(); d.enabled = false; setBiz(d); showBusinessInProfile(); }
    });
  }

  function showBusinessInProfile() {
    var body = q('acc-body'); if (!body) return;
    body.innerHTML = profileSubNav('business') + '<div style="margin-top:1rem">' + buildBusinessHtml() + '</div>';
    wireBusinessForm();
  }

  /* GST state code table */
  var GST_STATES = {
    '01':'Jammu & Kashmir','02':'Himachal Pradesh','03':'Punjab','04':'Chandigarh',
    '05':'Uttarakhand','06':'Haryana','07':'Delhi','08':'Rajasthan','09':'Uttar Pradesh',
    '10':'Bihar','11':'Sikkim','12':'Arunachal Pradesh','13':'Nagaland','14':'Manipur',
    '15':'Mizoram','16':'Tripura','17':'Meghalaya','18':'Assam','19':'West Bengal',
    '20':'Jharkhand','21':'Odisha','22':'Chhattisgarh','23':'Madhya Pradesh','24':'Gujarat',
    '27':'Maharashtra','29':'Karnataka','30':'Goa','32':'Kerala','33':'Tamil Nadu',
    '34':'Puducherry','36':'Telangana','37':'Andhra Pradesh'
  };

  window.smAccGstInput = function(inp) {
    inp.value = inp.value.toUpperCase();
    var info = q('biz-gst-info'); if (!info) return;
    var v = inp.value.trim();
    if (v.length >= 2) {
      var code = v.substring(0, 2);
      var state = GST_STATES[code];
      info.innerHTML = state
        ? '<span class="biz-gst-state">📍 Registered in '+state+'</span>'
        : '';
    } else { info.innerHTML = ''; }
  };

  window.smAccLookupGST = function() {}; /* GST API integration pending */

  window.smAccSaveBiz = function() {
    var enabled = q('biz-on') && q('biz-on').checked;
    var company = (q('biz-co') ? q('biz-co').value.trim() : '');
    var gstin   = (q('biz-gst') ? q('biz-gst').value.trim().toUpperCase() : '');
    if (enabled) {
      if (!company) { setMsg('biz-msg','Company name is required.','err'); return; }
      if (gstin && !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(gstin)) {
        setMsg('biz-msg','GSTIN format is invalid. Example: 27AABCU9603R1ZX','err'); return;
      }
    }
    var d = getBiz();
    d.enabled = enabled;
    d.company = company;
    d.gstin   = gstin;
    setBiz(d);
    setBiz(d);
    showBusinessInProfile(); /* re-render in view mode */
  };

  window.smAccSaveBilling = function() {
    var co = (q('bb-co') ? q('bb-co').value.trim() : '');
    var gt = (q('bb-gst') ? q('bb-gst').value.trim().toUpperCase() : '');
    var a1 = (q('bb-a1') ? q('bb-a1').value.trim() : '');
    var a2 = (q('bb-a2') ? q('bb-a2').value.trim() : '');
    var ct = (q('bb-ct') ? q('bb-ct').value.trim() : '');
    var st = (q('bb-st') ? q('bb-st').value.trim() : '');
    var zp = (q('bb-zp') ? q('bb-zp').value.trim() : '');
    var ph = (q('bb-ph') ? q('bb-ph').value.trim() : '');
    if (!a1||!ct||!st||!zp) { setMsg('bb-msg','Please fill Address Line 1, City, State and PIN Code.','err'); return; }
    var d = getBiz();
    d.billing = { company:co, gstin:gt, address1:a1, address2:a2, city:ct, state:st, zip:zp, phone:ph };
    setBiz(d);
    showBusinessInProfile(); /* re-render in view mode */
  };

  window.smAccEditBiz      = function() { window._bizEdit = true;  showBusinessInProfile(); };
  window.smAccEditBilling  = function() { window._billEdit = true; showBusinessInProfile(); };
  window.smAccCancelBilling = function() { showBusinessInProfile(); };

  /* ═══════════════════════════════════════════════════════════════════════
     INIT
  ═══════════════════════════════════════════════════════════════════════ */
  /* ── Password reset via ?reset=TOKEN link ── */
  function renderResetForm(resetToken) {
    root().innerHTML =
      '<div class="acc-auth">' +
        '<div class="acc-auth-logo"><a href="/"><img src="'+esc(LOGO)+'" alt="Sony Mony" height="34"></a></div>' +
        '<div id="pr-form">' +
          '<div class="acc-auth-title">Set New Password</div>' +
          '<div class="acc-auth-sub">Choose a strong password for your account.</div>' +
          '<div class="acc-field"><label>New Password</label>' +
            '<input id="pr-pw" class="acc-inp" type="password" autocomplete="new-password" placeholder="Min. 5 characters"></div>' +
          '<div class="acc-field"><label>Confirm Password</label>' +
            '<input id="pr-pw2" class="acc-inp" type="password" autocomplete="new-password" placeholder="Repeat password"></div>' +
          '<div id="pr-msg" class="acc-msg"></div>' +
          '<button class="acc-btn" id="pr-btn">Save Password</button>' +
        '</div>' +
        '<div id="pr-ok" style="display:none;text-align:center">' +
          '<div style="font-size:2.5rem;margin-bottom:1rem">✓</div>' +
          '<div class="acc-auth-title" style="color:#16a34a">Password Updated</div>' +
          '<div class="acc-auth-sub">Signing you in…</div>' +
        '</div>' +
      '</div>';

    q('pr-btn').addEventListener('click', function() {
      var pw  = q('pr-pw').value;
      var pw2 = q('pr-pw2').value;
      if (pw.length < 5)  { setMsg('pr-msg','Password must be at least 5 characters.','err'); return; }
      if (pw !== pw2)     { setMsg('pr-msg','Passwords do not match.','err'); return; }
      var btn = q('pr-btn'); btn.disabled=true; btn.textContent='Saving…';
      setMsg('pr-msg','','');

      fetch(NL_URL + '/reset-confirm', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: resetToken, password: pw })
      })
        .then(function(r) { return r.json(); })
        .then(function(res) {
          if (!res.ok) {
            btn.disabled=false; btn.textContent='Save Password';
            setMsg('pr-msg', res.error || 'Reset failed. The link may have expired.', 'err');
            return;
          }
          if (res.accessToken) {
            lss(TK, res.accessToken);
            lss(TX, res.expiresAt || '');
          }
          q('pr-form').style.display='none';
          q('pr-ok').style.display='';
          setTimeout(function() { window.location.href = '/pages/my-account'; }, 1800);
        })
        .catch(function() {
          btn.disabled=false; btn.textContent='Save Password';
          setMsg('pr-msg','Something went wrong. Please try again.','err');
        });
    });
    q('pr-pw').addEventListener('keydown', function(e) { if(e.key==='Enter') q('pr-pw2').focus(); });
    q('pr-pw2').addEventListener('keydown', function(e) { if(e.key==='Enter') q('pr-btn').click(); });
    if(q('pr-pw')) q('pr-pw').focus();
  }

  function init() {
    if (!q('acc-root')) return;
    if (!SF_TOK) {
      root().innerHTML = '<div class="acc-empty" style="padding:5rem 1rem"><div class="acc-empty-icon">⚙️</div><p>Account portal not configured. Please add the Storefront API token in Theme Settings.</p></div>';
      return;
    }
    /* Check for password reset link (?reset=TOKEN) */
    var urlParams = new URLSearchParams(window.location.search);
    var resetToken = urlParams.get('reset');
    if (resetToken) { renderResetForm(resetToken); return; }

    tok() ? renderDash() : renderAuth();
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
